import Account from 'views/account';

const routes = [
  {
    type: 'private',
    exact: true,
    path: '/account',
    app: true,
    component: Account,
    documentTitle: 'Account'
  }
];

export default routes;
